import Link from './Link';

export * from './LinkService';
export default Link;
